import WebMediaPlayer from './WebMediaPlayer';
import PlayerFactory from '../models/PlayerFactory';
import isMobile from '../../utils/isMobile';

export default class WebMediaPlayerFactory extends PlayerFactory {
  #icyMetadataEnabled;

  #playerId;

  constructor(icyMetadataEnabled) {
    super();

    this.#icyMetadataEnabled = icyMetadataEnabled;
    this.#playerId = 0;
    this.webMediaPlayerMobileInstance = null;
  }

  // mirroring JPlayer behavior for creating a singleton instance for mobile devices
  createPlayer() {
    this.#playerId++;

    if (!isMobile()) {
      return new WebMediaPlayer(this.#icyMetadataEnabled, this.#playerId);
    }

    if (!this.webMediaPlayerMobileInstance) {
      this.webMediaPlayerMobileInstance = new WebMediaPlayer(
        this.#icyMetadataEnabled,
        this.#playerId,
        true,
      );
    }

    return this.webMediaPlayerMobileInstance;
  }
}
